// svg images
import arrow from "./assets/arrow-up.svg";
import direction from "./assets/wind-white.svg";
import location from "./assets/location.svg";
import close from "./assets/close-circle.svg";
import pressure from "./assets/air-pressure.svg";
import rain from "./assets/rain.svg";
import visibility from "./assets/visibility.svg";

// wallpapers
import bgWall from "./assets/bg-wallpaper.jpeg";

// weather icons
import a01d from "./assets/icons/a01d.png";
import a02d from "./assets/icons/a02d.png";
import a03d from "./assets/icons/a03d.png";
import a04d from "./assets/icons/a04d.png";
import a05d from "./assets/icons/a05d.png";
import a06d from "./assets/icons/a06d.png";

import a01n from "./assets/icons/a01n.png";
import a02n from "./assets/icons/a02n.png";
import a03n from "./assets/icons/a03n.png";
import a04n from "./assets/icons/a04n.png";
import a05n from "./assets/icons/a05n.png";
import a06n from "./assets/icons/a06n.png";

// Night Clouds
import c01n from "./assets/icons/c01n.png";
import c02n from "./assets/icons/c02n.png";
import c03n from "./assets/icons/c03n.png";
import c04n from "./assets/icons/c04n.png";

// Day Clouds
import c01d from "./assets/icons/c01d.png";
import c02d from "./assets/icons/c02d.png";
import c03d from "./assets/icons/c03d.png";
import c04d from "./assets/icons/c04d.png";

// Night Drizzle
import d01n from "./assets/icons/d01n.png";
import d02n from "./assets/icons/d02n.png";
import d03n from "./assets/icons/d03n.png";

// Day Drizzle
import d01d from "./assets/icons/d01d.png";
import d02d from "./assets/icons/d02d.png";
import d03d from "./assets/icons/d03d.png";

// Fog
import f01n from "./assets/icons/f01n.png";
import f01d from "./assets/icons/f01d.png";

// Night Rain
import r01n from "./assets/icons/r01n.png";
import r02n from "./assets/icons/r02n.png";
import r03n from "./assets/icons/r03n.png";
import r04n from "./assets/icons/r04n.png";
import r05n from "./assets/icons/r05n.png";
import r06n from "./assets/icons/r06n.png";

// Day Rain
import r01d from "./assets/icons/r01d.png";
import r02d from "./assets/icons/r02d.png";
import r03d from "./assets/icons/r03d.png";
import r04d from "./assets/icons/r04d.png";
import r05d from "./assets/icons/r05d.png";
import r06d from "./assets/icons/r06d.png";

// Night Snow
import s01n from "./assets/icons/s01n.png";
import s02n from "./assets/icons/s02n.png";
import s03n from "./assets/icons/s03n.png";
import s04n from "./assets/icons/s04n.png";
import s05n from "./assets/icons/s05n.png";
import s06n from "./assets/icons/s06n.png";

// Day Snow
import s01d from "./assets/icons/s01d.png";
import s02d from "./assets/icons/s02d.png";
import s03d from "./assets/icons/s03d.png";
import s04d from "./assets/icons/s04d.png";
import s05d from "./assets/icons/s05d.png";
import s06d from "./assets/icons/s06d.png";

// Night Thunderstorm
import t01n from "./assets/icons/t01n.png";
import t02n from "./assets/icons/t02n.png";
import t03n from "./assets/icons/t03n.png";
import t04n from "./assets/icons/t04n.png";
import t05n from "./assets/icons/t05n.png";

// Day Thunderstorm
import t01d from "./assets/icons/t01d.png";
import t02d from "./assets/icons/t02d.png";
import t03d from "./assets/icons/t03d.png";
import t04d from "./assets/icons/t04d.png";
import t05d from "./assets/icons/t05d.png";

// Unknown Precipitation
import u00n from "./assets/icons/u00n.png";
import u00d from "./assets/icons/u00d.png";

const weatherIcons = {
  a01d,
  a02d,
  a03d,
  a04d,
  a05d,
  a06d,
  a01n,
  a02n,
  a03n,
  a04n,
  a05n,
  a06n,
  c01d,
  c02d,
  c03d,
  c04d,
  c01n,
  c02n,
  c03n,
  c04n,
  d01d,
  d02d,
  d03d,
  d01n,
  d02n,
  d03n,
  f01n,
  f01d,
  r01n,
  r02n,
  r03n,
  r04n,
  r05n,
  r06n,
  r01d,
  r02d,
  r03d,
  r04d,
  r05d,
  r06d,
  s01n,
  s02n,
  s03n,
  s04n,
  s05n,
  s06n,
  s01d,
  s02d,
  s03d,
  s04d,
  s05d,
  s06d,
  t01n,
  t02n,
  t03n,
  t04n,
  t05n,
  t01d,
  t02d,
  t03d,
  t04d,
  t05d,
  u00d,
  u00n,
};
const img = {
  arrow,
  direction,
  location,
  close,
  pressure,
  visibility,
  rain,
  bgWall,
};

export { img, weatherIcons };
